import React from 'react';
import { Box, LinearProgress } from '@mui/material';

import { useHasRole } from '@homesusa/auth';
import { AppContext } from '../../contexts';
import { Content } from '../content.component';
import { Sidebar } from '../sidebar/sidebar.component';
import { DrawerStyled } from './drawer.style';

export function Drawer({ children }: { children: React.ReactNode }): JSX.Element {
  const {
    appState: {
      layout: {
        sidebar: { openSubSidebar }
      }
    }
  } = React.useContext(AppContext);

  const { isLoading } = useHasRole();

  if (isLoading()) {
    return (
      <Box sx={{ width: '100%' }}>
        <LinearProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <DrawerStyled variant='permanent' open={openSubSidebar}>
        <Sidebar />
      </DrawerStyled>
      <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
        <Content>{children}</Content>
      </Box>
    </Box>
  );
}
